import { newToolFilterOAuthMcp } from "../oauth.ts";

export const sentryMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://sentry-brand.storage.googleapis.com/sentry-glyph-black.svg",
  url: "https://mcp.sentry.dev/mcp",
  label: "Sentry",
});
